import { Link } from "react-router-dom";
import img2 from "../assets/juventud1.jpeg";
import img3 from "../assets/juventud2.jpeg";
import img4 from "../assets/juventud3.jpeg";
import img5 from "../assets/juventud4.jpeg";
import img6 from "../assets/juventud5.jpeg";
import img7 from "../assets/juventud6.jpeg";
import img8 from "../assets/juventud7.jpeg";
import img9 from "../assets/juventud8.jpeg";
import img10 from "../assets/juventud9.jpeg";
import img11 from "../assets/juventud10.jpeg";
import img12 from "../assets/juventud11.jpeg";
import img13 from "../assets/juventud12.jpeg";
import img1 from "../assets/juventud13.jpeg";

import logofundacion1 from "../assets/logofundacion1.png";
import ReactWhatsapp from "react-whatsapp";
import React, { useEffect, useState } from "react";
import fondo from "../assets/fondo9.png";

export default function Juventud() {
  const imagenes = [img1,img2, img3, img4,img5,img6,img7,img8,img9,img10,img11,img12,img13];

  const [indiceImagen, setIndiceImagen] = useState(0);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setIndiceImagen((prev) => (prev + 1) % imagenes.length);
    }, 3000);

    return () => clearInterval(intervalo);
  }, [imagenes.length]);

  return (
    <div className=" min-h-screen text-white flex flex-col">
      
      {/* Encabezado con botón de regreso */}
      <header className="bg-white text-green-two p-1 flex justify-between items-center">
        <div className="h-full">
          <img
            src={logofundacion1}
            alt="Logo Fundación Manitas de Colores"
            className="pt-2 rounded-2xl mx-auto md:h-18 h-20"
          />
        </div>

        <h1 className="text-2xl font-bold hidden lg:block">
          Juventud Jóvenes en Acción
        </h1>

        <Link
          to="/"
          className="bg-orange-one hover:bg-orange-600 text-white px-2 py-2 rounded"
        >
          ← Volver al inicio
        </Link>
      </header>

      {/* Contenido principal */}
      <main className="flex-1 p-8">
        <div
          name="quehacemos"
          className="w-full bg-cover bg-center relative"
          style={{
            backgroundImage: `url(${fondo})`,
          }}
        >
          <div className="max-w-screen-lg px-4 mx-auto flex flex-col md:flex-row items-center md:justify-center w-full h-full gap-8 pt-4 md:pt-10">
            
            {/* TEXTO */}
            <div className="w-full md:w-1/2">
              <p className="text-2xl sm:text-4xl md:text-4xl lg:text-4xl xl:text-4xl font-bold text-orange-one">
                Presentamos el grupo Juventud Jóvenes en Acción
              </p>

              <p className="text-1xl sm:text-2xl mt-6 text-green-one">
                <strong>Grupo objetivo:</strong> Jóvenes de 12 a 22 años, impulsándolos a descubrir sus capacidades, fortalecer su formación y construir un futuro con propósito.
              </p>

              <p className="text-1xl sm:text-2xl mt-6 text-green-one">
                <strong>❤️ Tu apoyo puede ser el impulso que necesitan para avanzar.</strong> Con tu donación podemos brindarles oportunidades para aprender, crecer y convertirse en agentes de cambio en su comunidad.
                 Súmate y sé parte de su futuro.
              </p>

              {/* BOTÓN CENTRADO */}
              <div className="mt-4 flex justify-center">
                <ReactWhatsapp
                  number="+59162211995"
                  message="Saludos, necesito Información sobre la Fundación Manitas de Colores"
                  element="text"
                >
                  <button className="bg-orange-one hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded-full shadow-md">
                    Contáctanos
                  </button>
                </ReactWhatsapp>
              </div>
            </div>

            {/* IMAGEN */}
            <div className="w-full md:w-1/2 flex justify-center">
              <img
                src={imagenes[indiceImagen]}
                alt={`Juventud Jóvenes en Acción ${indiceImagen + 1}`}
                className="rounded-xl object-cover w-full max-w-md h-[280px] sm:h-[340px] md:h-[420px] lg:h-[480px] shadow-lg"              />
            </div>

          </div>
        </div>
      </main>
    </div>
  );
}